import { keepPreviousData, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { Purchase, PurchaseFilters } from '../types';
import { usePurchasingApi } from './use-purchasing-api';

// queryKey/queryFn are owned by the hook; the rest of the query options pass through.
export type PurchasesQueryOptions = Omit<UseQueryOptions<Purchase[]>, 'queryKey' | 'queryFn'>;

const QK_GET_PURCHASES = (filters?: PurchaseFilters) => ['purchases', 'list', filters] as const;

export function usePurchases(filters?: PurchaseFilters, options: PurchasesQueryOptions = {}) {
  const { purchasingApi } = usePurchasingApi();

  return useQuery<Purchase[]>({
    placeholderData: keepPreviousData,
    ...options,
    queryKey: QK_GET_PURCHASES(filters),
    queryFn: () => purchasingApi.getPurchases(filters),
  });
}
